import Vue from 'vue'
import VueRouter from 'vue-router'
import store from '@/store'

import Login from '@/views/Login'
import Dashboard from '../views/Dashboard.vue'
import EditUserPage from '@/views/EditUserPage'
import Individuals from '@/views/IndividualsPage'
import CourseTemplatePage from '@/views/CourseTemplatePage'
import LessonTemplatePage from '@/views/LessonTemplatePage'
import UnitTemplatePage from '@/views/UnitTemplatePage'
import ElementTemplatePage from '@/views/ElementsTemplatePage'
import CriteriaTemplatePage from '@/views/CriteriaTemplatePage'
import AddCourse from '@/views/AddCourse'
import AddLesson from '@/views/AddLesson'
import AddUnit from '@/views/AddUnit'
import AddElement from '@/views/AddElement'
import AddCriteria from '@/views/AddCriteria'
import EditCourseTemplate from '@/views/EditTemplate'
import EditLessonTemplate from '@/views/EditLesson'
import EditUnitTemplate from '@/views/EditUnit'
import EditElementTemplate from '@/views/EditElement'
import EditCriteriaTemplate from '@/views/EditCriteria'
import CourseAssign from '@/views/CourseAssign'
import CourseAssignLessons from '@/views/CourseAssignLessons'
import ViewCourses from '@/views/ViewCourses'
import ResetPassword from '@/views/ResetPassword'


Vue.use(VueRouter);

let routes = [
    {
        path: '*',
        redirect: '/'
    },
    {
        path: '/',
        component: Dashboard,
        children: [
            {
                path: '/user/edit/:id',
                name: 'Edit User',
                exact: true,
                component: EditUserPage
            },
            {
                path: '/user/add/',
                name: 'Add User',
                exact: true,
                component: EditUserPage
            },
            {
                path: '/templates/',
                name: 'Course Templates',
                component: CourseTemplatePage,
            },
            {
                path: '/',
                name: 'View Users',
                component: Individuals,
            },
            {
                path: '/templates/:courseTemplateId/lessons',
                name: 'Lessons',
                component: LessonTemplatePage,
            },
            {
                path: '/templates/:courseTemplateId/lessons/:lessonTemplateId/units',
                name: 'Units',
                component: UnitTemplatePage,
            },
            {
                path: '/templates/:courseTemplateId/lessons/:lessonTemplateId/units/:unitTemplateId/elements',
                name: 'Elements',
                component: ElementTemplatePage,
            },
            {
                path: '/templates/:courseTemplateId/lessons/:lessonTemplateId/units/:unitTemplateId/elements/:elementTemplateId',
                name: 'Criteria',
                component: CriteriaTemplatePage,
            },
            {
                path: '/template/add',
                name: 'Add Course',
                component: AddCourse
            },
            {
                path: '/templates/:courseTemplateId/lessons/add',
                name: 'Add Lesson',
                component: AddLesson
            },
            {
                path: '/templates/:courseTemplateId/lessons/:lessonTemplateId/unit/add',
                name: 'Add Unit',
                component: AddUnit
            },
            {
                path: '/templates/:courseTemplateId/lessons/:lessonTemplateId/units/:unitTemplateId/element/add',
                name: 'Add Element',
                component: AddElement
            },
            {
                path: '/templates/:courseTemplateId/lessons/:lessonTemplateId/units/:unitTemplateId/elements/:elementTemplateId/criteria/add',
                name: 'Add Criteria',
                component: AddCriteria
            },
            {
                path: '/template/edit/:courseTemplateId',
                name: 'Edit Course',
                component: EditCourseTemplate
            },
            {
                path: '/lesson/edit/:lessonTemplateId',
                name: 'Edit Lesson',
                component: EditLessonTemplate
            },
            {
                path: '/unit/edit/:unitTemplateId',
                name: 'Edit Unit',
                component: EditUnitTemplate
            },
            {
                path: '/element/edit/:elementTemplateId',
                name: 'Edit Element',
                component: EditElementTemplate
            },
            {
                path: '/criteria/edit/:criteriaTemplateId',
                name: 'Edit Criteria',
                component: EditCriteriaTemplate
            },
            {
                path: '/course-assign',
                name: 'Select a Course',
                component: CourseAssign
            },
            {
                path: '/course-assign/:courseId/lessons',
                name: 'Select Lessons',
                component: CourseAssignLessons
            },


            {
                path: '/courses',
                name: 'View Courses',
                component: ViewCourses
            }
        ],
        beforeEnter: (to, from, next) => {
            if (store.state.isAuth) {
                next();
            } else {
                next('/login');
            }
        }
    },
    {
        path: '/login',
        name: 'login',
        component: Login,
        beforeEnter:(to, from, next) => {
            if (store.state.isAuth) {
                next('/?page=1')
            } else {
                next();
            }
        }
    },
    {
        path: '/reset-password',
        name: 'Reset Password',
        exact: true,
        component: ResetPassword
    }
];

const router = new VueRouter({
    mode: 'history',
    base: process.env.BASE_URL,
    routes: routes,
});

export default router
